import {ContainsMultipleFilter} from "./contains-multiple.filter";
import {FilterObject} from "./filter-object";
import * as lodash from "lodash";

export class ContainsMultipleUnifiedValueFilter extends FilterObject<any> {

    containtsMultiple = new ContainsMultipleFilter();

    filter(itemToFiltre: any): boolean {
        return this.doFilter(itemToFiltre, this.field, this.values);
    }

    doFilter(itemToFiltre: any, field: any, values: any): boolean {
        if (values == null) {
            return true;
        }
        let result = true;
        if (field == null) {
            field = Object.keys(itemToFiltre);
        }


        if (Array.isArray(values)) {
            values.forEach(value => {
                result = result || this.containtsMultiple.doFilter(itemToFiltre, field, value);
            });
        }
        else {
            let words: Array<string> = values.split(' ');
            lodash.remove(words, obj => {
                return obj == "";
            });
            words.forEach(value => {
                result = result && this.containtsMultiple.doFilter(itemToFiltre, field, value);
            });

        }

        return result;
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/contains-multiple-unified-value.filter.ts